class AAHeadquarters {
  constructor(root) {
    this.root = root;
    this.init();
  }

  async init() {
    // Internal Headquarters is closed until the signed-in user's role
    // has been verified. No client modules may load before this check.
    let auth;
    try {
      if (typeof window.AAWorkspaceContext?.getWorkspaceAuthContext !== 'function') {
        throw new Error('Workspace authentication unavailable');
      }
      auth = await window.AAWorkspaceContext.getWorkspaceAuthContext();
    } catch (error) {
      console.error('Unable to verify Headquarters access:', error);
      window.location.replace('/pages/workspace-login');
      return;
    }

    if (!auth?.user || auth.locked) {
      window.location.replace('/pages/workspace-login');
      return;
    }

    if (!auth.isInternal || !['aa_admin', 'aa_team'].includes(auth.role)) {
      window.location.replace('/pages/workspace-permission-denied');
      return;
    }

    this.root.hidden = false;
    this.initClients();
    this.initTaskGenerator();
    this.initTemplateBuilder();
    this.initTasks();
    this.initOperations();
    this.initDashboard();
  }

  initClients() {
    const clientsRoot = this.root.querySelector('[data-aa-clients-list]');
    if (!clientsRoot || !window.AAHeadquartersClients) return;

    new window.AAHeadquartersClients(this.root);
  }

  initTaskGenerator() {
    if (
      !window.AATaskGeneratorWorkspace
    ) {
      return;
    }

    new window.AATaskGeneratorWorkspace(
      this.root
    );
  }

  initTemplateBuilder() {
    const builderRoot = this.root.querySelector('[data-aa-template-builder], [data-aa-playbook-builder]');
    if (!builderRoot || !window.AATemplateBuilder) return;

    new window.AATemplateBuilder(this.root);
  }

  initTasks() {
    const tasksRoot =
      this.root.querySelector(
        '[data-aa-task-workspace]'
      );

    if (
      !tasksRoot ||
      !window.AATasksWorkspace
    ) {
      return;
    }

    new window.AATasksWorkspace(
      tasksRoot
    );
  }

  initOperations() {
    const operationsRoot =
      this.root.querySelector(
        '[data-aa-operations-workspace]'
      );

    if (
      !operationsRoot ||
      !window.AAOperationsWorkspace
    ) {
      return;
    }

    new window.AAOperationsWorkspace(
      operationsRoot
    );
  }


  initDashboard() {
    const dashboardRoot =
      this.root.querySelector(
        '[data-aa-dashboard-workspace]'
      );

    if (
      !dashboardRoot ||
      !window.AAHeadquartersDashboard
    ) {
      return;
    }

    new window.AAHeadquartersDashboard(
      dashboardRoot
    );
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-aa-headquarters]').forEach((root) => {
    new AAHeadquarters(root);
  });
});
